module.exports = __webpack_public_path__ + "static/img/ban-10.55c81e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ban-10.png
// module id = mOoq
// module chunks = 0